import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
  background: "#FCF9F7",

  [props.theme.breakpoints.down("lg")]: {
    padding: "56px 32px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  position: "relative",
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  flexDirection: "column",
  alignItems: "center",
  gap: "40px",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "column-reverse",
    maxWidth: "600px",
    alignItems: "center",
    gap: "40px",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    textAlign: "center",
    gap: "20px",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  justifyContent: "space-between",
  alignItems: "stretch",
  gap: "40px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "1200px",
    flexDirection: "column-reverse",
    alignItems: "center",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "center",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "32px",
    textAlign: "center",
  },
}));

export const CardImage = styling("img")((props) => ({
  width: "50%",
  // height: "100%",
  borderRadius: "12px",
  maxHeight: "580px",
  maxWidth: "50%",
  objectFit: "cover",
  boxShadow: "-4px 4px 14px 0 rgba(0, 0, 0, 0.25)",

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
    maxWidth: "650px",
    height: "auto",
  },

  [props.theme.breakpoints.down("tablet")]: {
    minHeight: "215px",
    maxWidth: "100%",
    marginLeft: "-10px",
    paddingRight: 0,
    // paddingRight: "20px",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "24px",
  width: "50%",

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
    maxWidth: "720px",
    alignItems: "center",
    padding: "0px",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardText = styling(Typography)((props) => ({
  color: props.type == "desc" ? "#120146" : "#40249B",
  fontFamily: props.type == "desc" ? "Inter" : "Georgia",
  fontSize: props.type == "desc" ? "20px" : "64px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 500 : 400,
  lineHeight: props.type == "desc" ? "30px" : "76.8px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "0.64px",

  "& i": {
    color: "#512ACC",
  },

  [props.theme.breakpoints.down("lg")]: {
    textAlign: props.type == "desc" ? "center" : "center",
    fontSize: props.type == "desc" ? "20px" : "36px",
    lineHeight: props.type == "desc" ? "30px" : "43.2px",
    letterSpacing: props.type == "desc" ? "0.03px" : "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "22.4px" : "28.8px",
    textAlign: props.type == "desc" ? "center" : "center",
    letterSpacing: props.type == "desc" ? "unset" : "0.036px",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const YellowSticker = styling("div")((props) => ({
  position: "absolute",
  display: "flex",
  padding: "12px 24px",
  alignItems: "center",
  right: "-30px",
  top: "-35px",
  borderRadius: "40px",
  background: "#512ACC",
  boxShadow: "0 4px 9.8px 0 rgba(0, 0, 0, 0.25)",
  flexDirection: "column",
  color: "rgba(255, 255, 255, 0.87)",

  "& p": {
    fontSize: "14px",
    margin: "0px",
    display: "flex",
    gap: "6px",
    alignItems: "center",
  },

  "& i": {
    fontSize: "24px",
    fontWeight: 700,
    fontStyle: "normal",
  },

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    padding: "8px 12px",
    right: "-5px",
    top: "-25px",

    "& p": {
      fontSize: "8px",
      lineHeight: "12px",
      letterSpacing: "0.15px",
    },

    "& b": {
      fontSize: "10px",
      lineHeight: "15px",
    },

    "& i": {
      fontSize: "12px",
      fontWeight: 700,
      lineHeight: "16.8px",
    },
  },
}));
